import { SafeError, SafePromise, SafeType } from '@benzinga/safe-await';
import { AuthorId, Author } from './entities/article';

export interface IncomingAuthor {
  uid: AuthorId;
  name: string;
  byline: string;
  profile_url: string;
  lastname: string;
  firstname: string;
  about?: string;
  company_title?: string;
  company_url?: string;
  facebook?: string;
  twitter?: string;
  linkedin?: string;
  picture?: string;
}

interface RestfulResult<DATA> {
  data: DATA;
  response_code: number;
}

export type IncomingAuthorResult = RestfulResult<IncomingAuthor>;

export const ingestAuthor = async (authorData: SafePromise<IncomingAuthorResult>): SafePromise<Author> => {
  const rawAuthor = await authorData;

  if (rawAuthor.err) {
    return rawAuthor as SafeType<Author>;
  } else {
    const data = rawAuthor?.ok?.data;
    if (data) {
      return {
        ok: {
          about: data.about,
          byLine: data.byline,
          companyTitle: data.company_title,
          companyUrl: data.company_url,
          facebook: data.facebook,
          firstname: data.firstname,
          lastname: data.lastname,
          linkedin: data.linkedin,
          name: data.name,
          picture: data.picture,
          profileUrl: data.profile_url,
          twitter: data.twitter,
          uid: data.uid,
        },
      };
    } else {
      return { err: new SafeError('did not get a valid author', 'invalid_author') };
    }
  }
};
